document.addEventListener('DOMContentLoaded', function () {
  const initReadMore = () => {
    const containers = document.querySelectorAll('[data-read-more-container]');

    containers.forEach(container => {
      const description = container.querySelector('[data-description]');
      const button = container.querySelector('[data-read-more-toggle]');

      if (!description || !button) {
        return;
      }

      if (description.scrollHeight > description.clientHeight) {
        button.classList.remove('hidden');
      }

      button.addEventListener('click', () => {
        const isTruncated = description.classList.contains('description-truncate');
        description.classList.toggle('description-truncate');
        button.textContent = isTruncated ? 'Read Less' : 'Read More';
      });
    });
  };

  // Wait for fonts to be loaded to ensure correct height calculation.
  if (document.fonts) {
    document.fonts.ready.then(initReadMore);
  } else {
    // Fallback for older browsers that don't support document.fonts
    setTimeout(initReadMore, 150);
  }
});